module.exports = __webpack_public_path__ + "static/media/museum_diorama_mural_concept_2007.d91a32ec.webp";